import React from 'react';
const getBiAttribute = (target, context) => target
    ?.closest(`[data-bi*=${context}]`)
    ?.getAttribute('data-bi');
export const DataBiBoundary = ({ children, dataBi, metadata, }) => {
    const { hooks, callbacks } = dataBi;
    const dataBiToHook = Object.entries(hooks).reduce((acc, [hook, dataBi_]) => ({
        ...acc,
        [dataBi_]: hook,
    }), {});
    React.useEffect(() => {
        callbacks.onContextMountEvent?.(metadata ?? {});
        return () => callbacks.onContextUnmountEvent?.(metadata ?? {});
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { onMouseOverCapture: !callbacks.onHoverEvents
                ? undefined
                : (evt) => {
                    const dataBi_ = evt.target &&
                        getBiAttribute(evt.target, hooks.context);
                    if (dataBi_) {
                        const hook = dataBiToHook[dataBi_];
                        hook &&
                            callbacks.onHoverEvents?.[hook]?.(metadata ?? {});
                    }
                }, onClickCapture: (evt) => {
                const dataBi_ = evt.target &&
                    getBiAttribute(evt.target, hooks.context);
                if (dataBi_) {
                    const hook = dataBiToHook[dataBi_];
                    const onClickEvent = `${hook}OnClick`;
                    onClickEvent && callbacks[onClickEvent]?.(metadata ?? {});
                }
            } }, children)));
};
//# sourceMappingURL=BiEventsBoundary.js.map